import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface DetachCandidateFromCaseResponse extends BackendResponse {
  item: boolean;
}
export interface DetachCandidateFromCaseParameters extends NextApiParams {
  typeRelated: number;
  idRelated: number;
}

export const detachCandidateFromCase = withNextApi<
  DetachCandidateFromCaseResponse,
  DetachCandidateFromCaseParameters
>("/cvp/CvpDetachCandidateFromCase");
